function SpacesLeft({ screenWidth, handleOpenSXPSite }) {
  let Colors = [
    { Availibiltiy: "Good", Color: "rgba(6, 134, 47, 0.5)" },
    { Availibiltiy: "Few places left", Color: "rgba(249, 128, 7, 0.5)" },
    { Availibiltiy: "Close to full", Color: "rgba(249, 7, 7, 0.5)" },
    { Availibiltiy: "Closed", Color: "Grey" },
  ];

  let AllProgrammesAvailibility = [
    {
      Career: "Architect",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Artist",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Computer Scientist",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Dentist",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Doctor",
      Date: "7th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Doctor",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Doctor",
      Date: "18th August",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Engineer",
      Date: "7th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Engineer",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Engineer",
      Date: "18th August",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Entrepreneur",
      Date: "7th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Entrepreneur",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Fashion Designer",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Filmmaker",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Forensic Scientist",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "International Politics",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Investment Banker",
      Date: "7th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Investment Banker",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Investment Banker",
      Date: "18th August",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Lawyer",
      Date: "7th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Lawyer",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Lawyer",
      Date: "18th August",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Psychologist",
      Date: "7th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Psychologist",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
    {
      Career: "Vet",
      Date: "28th July",
      One_Week: Colors[3].Availibiltiy,
      Two_Week: Colors[3].Availibiltiy,
      Premium: Colors[3].Availibiltiy,
    },
  ];

  let AllDates = [
    { Date: "7th July", Deadline: "2nd June" },
    { Date: "28th July", Deadline: "30th June" },
    { Date: "18th August", Deadline: "21st July" },
  ];

  let AllCareers = [
    "Architect",
    "Artist",
    "Computer Scientist",
    "Dentist",
    "Doctor",
    "Engineer",
    "Entrepreneur",
    "Fashion Designer",
    "Filmmaker",
    "Forensic Scientist",
    "International Politics",
    "Investment Banker",
    "Lawyer",
    "Psychologist",
    "Vet",
  ];

  function givenCareerAndDateFindProgramme(career, date) {
    let found = AllProgrammesAvailibility.find(
      (x) => x.Career === career && x.Date === date
    );
    return found;
  }

  return (
    <div
      class="w3-row-padding w3-center w3-padding-64 w3-theme-l4"
      id="pricing"
    >
      <link rel="stylesheet" href="https://www.w3schools.com/w3css/4/w3.css" />
      <link
        rel="stylesheet"
        href="https://www.w3schools.com/lib/w3-theme-black.css"
      />
      <link
        rel="stylesheet"
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css"
      />
      <style jsx>{`
        #BookingTable {
          font-family: Arial, Helvetica, sans-serif;
          border-collapse: collapse;
          width: 100%;
        }

        #BookingTable td,
        #BookingTable th {
          border: 1px solid #ddd;
          padding: 8px;
          text-align: center;
          width: calc(75% / 9); /* Ensures equal width for all columns */
        }

        #BookingTable tr:nth-child(odd) {
          background-color: #ffffff;
        }

        #BookingTable tr:hover {
          background-color: #ddd;
        }

        #BookingTable th {
          padding-top: 12px;
          padding-bottom: 12px;
          background-color: #04aa6d;
          color: white;
        }
      `}</style>
      <div>
        <h2>Programme Availibility</h2>
        <p>
          Green = Good Availibility
          <br></br>
          Orange = Close to full
          <br></br>
          Red = Only a few places left
          <br></br>
          Dark Grey = Closed
        </p>
      </div>
      {screenWidth === "Small" ? (
        //MOBILE VIEW
        <div
          style={{ display: "flex", flexWrap: "wrap", flexDirection: "row" }}
        >
          {AllDates.map((date) => {
            return (
              <div
                class="w3-third w3-margin-bottom"
                style={{
                  width: screenWidth === "Small" ? "99%" : "",
                }}
              >
                <ul class="w3-ul w3-border w3-hover-shadow">
                  <li class="w3-theme">
                    <p class="w3-xlarge">
                      {date.Date}
                      <br></br>
                      Application Deadline: {date.Deadline}
                    </p>
                  </li>
                  {AllCareers.map((career) => {
                    let foundObj = givenCareerAndDateFindProgramme(
                      career,
                      date.Date
                    );
                    if (foundObj) {
                      return (
                        <div
                          style={{
                            display: "flex",
                            flexDirection: "column",
                            marginBottom: "16px",
                          }}
                        >
                          <li
                            class="w3-padding-16"
                            style={{
                              backgroundColor: "lightgray",
                              textAlign: "center",
                              fontWeight: "bold",
                            }}
                            key={`${career}-Header`}
                          >
                            {foundObj.Career}
                          </li>
                          <div
                            style={{
                              display: "flex",
                              flexDirection: "row",
                              justifyContent: "space-between",
                            }}
                          >
                            <li
                              class="w3-padding-16"
                              style={{
                                backgroundColor: Colors.find(
                                  (x) => x.Availibiltiy === foundObj.One_Week
                                ).Color,
                                width: "33%",
                                textAlign: "center",
                                textDecoration:
                                  foundObj.One_Week === "Closed"
                                    ? "line-through"
                                    : "none",
                              }}
                              key={`${career}-One_Week`}
                            >
                              <i>One Week</i>
                            </li>
                            <li
                              class="w3-padding-16"
                              style={{
                                backgroundColor: Colors.find(
                                  (x) => x.Availibiltiy === foundObj.Two_Week
                                ).Color,
                                width: "33%",
                                textAlign: "center",
                                textDecoration:
                                  foundObj.Two_Week === "Closed"
                                    ? "line-through"
                                    : "none",
                              }}
                              key={`${career}-Two_Week`}
                            >
                              <i>Two Week</i>
                            </li>
                            <li
                              class="w3-padding-16"
                              style={{
                                backgroundColor: Colors.find(
                                  (x) => x.Availibiltiy === foundObj.Premium
                                ).Color,
                                width: "33%",
                                textAlign: "center",
                                textDecoration:
                                  foundObj.Premium === "Closed"
                                    ? "line-through"
                                    : "none",
                              }}
                              key={`${career}-Premium`}
                            >
                              <i>Premium</i>
                            </li>
                          </div>
                        </div>
                      );
                    } else {
                      return null;
                    }
                  })}
                </ul>
              </div>
            );
          })}
        </div>
      ) : (
        //DESKTOP VIEW
        <>
          <table id="BookingTable">
            <thead>
              <tr>
                <th style={{ width: "25%" }}>Availibility</th>
                <th colSpan="3">
                  {AllDates[0].Date}
                  <br></br>
                  Applciation Deadline: {AllDates[0].Deadline}
                </th>
                <th colSpan="3">
                  {AllDates[1].Date}, Applciation Deadline:{" "}
                  {AllDates[1].Deadline}
                </th>
                <th colSpan="3">
                  {AllDates[2].Date}, Applciation Deadline:{" "}
                  {AllDates[2].Deadline}
                </th>
              </tr>
              <tr>
                <th>Lengths</th>
                <th>1 Week</th>
                <th>2 Week</th>
                <th>Premium</th>
                <th>1 Week</th>
                <th>2 Week</th>
                <th>Premium</th>
                <th>1 Week</th>
                <th>2 Week</th>
                <th>Premium</th>
              </tr>
            </thead>
            <tbody>
              {AllCareers.map((career) => {
                return (
                  <tr key={career}>
                    <td>{career}</td>
                    {AllDates.map((date) => {
                      let foundObj = givenCareerAndDateFindProgramme(
                        career,
                        date.Date
                      );
                      if (foundObj) {
                        return (
                          <>
                            <td
                              key={`${career}-${date.Date}-One_Week`}
                              style={{
                                backgroundColor: Colors.find(
                                  (x) => x.Availibiltiy === foundObj.One_Week
                                ).Color,
                              }}
                            ></td>
                            <td
                              key={`${career}-${date.Date}-Two_Week`}
                              style={{
                                backgroundColor: Colors.find(
                                  (x) => x.Availibiltiy === foundObj.Two_Week
                                ).Color,
                              }}
                            ></td>
                            <td
                              key={`${career}-${date.Date}-Premium`}
                              style={{
                                backgroundColor: Colors.find(
                                  (x) => x.Availibiltiy === foundObj.Premium
                                ).Color,
                              }}
                            ></td>
                          </>
                        );
                      } else {
                        return (
                          <>
                            <td
                              key={`${career}-${date.Date}-One_Week`}
                              style={{ backgroundColor: "white" }}
                            ></td>
                            <td
                              key={`${career}-${date.Date}-Two_Week`}
                              style={{ backgroundColor: "white" }}
                            ></td>
                            <td
                              key={`${career}-${date.Date}-Premium`}
                              style={{ backgroundColor: "white" }}
                            ></td>
                          </>
                        );
                      }
                    })}
                  </tr>
                );
              })}
            </tbody>
          </table>
        </>
      )}
    </div>
  );
}

export default SpacesLeft;
